export default {
  install(Vue)  {
    Vue.prototype.setLocalStorage = function(key,value) {
      var curtime = new Date().getTime(); // 获取当前时间 ，转换成JSON字符串序列
      var valueDate = JSON.stringify({
        val: value,
        timer: curtime
      });
      localStorage.setItem(key, valueDate)
    }
    Vue.prototype.getLocalStorage = function(key){
      var exp = 60 * 60 * 24 * 1000 * 30; // 一天的秒数
      if (localStorage.getItem(key)) {
        var vals = localStorage.getItem(key); // 获取本地存储的值
        var dataObj = JSON.parse(vals); // 将字符串转换成JSON对象
        // 如果(当前时间 - 存储的元素在创建时候设置的时间) > 过期时间
        var isTimed = new Date().getTime() - dataObj.timer > exp;
        if (isTimed) {
          localStorage.removeItem(key);
          return null;
        } else {
          var newValue = dataObj.val;
        }
        return newValue;
      } else {
        return null;
      }
    }
    Vue.prototype.getLang = function(){
      let baseLang
      // if (navigator.userLanguage) {  
      //   baseLang = navigator.userLanguage.substring(0,2).toLowerCase();  
      // } else {  
      //   baseLang = navigator.language.substring(0,2).toLowerCase();  
      // }
      baseLang = window.localStorage.getItem("localeLanguage")
      switch(baseLang){
        case "en": 
          return 'en'
        case "zh": 
          return 'cn'
        default:  
          return 'cn'
      }
    },

    Vue.prototype.millonFormat = function (n) {
      let regPos = /^\d+(\.\d+)?$/; //非负浮点数
      let regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数      
      if(regPos.test(n) || regNeg.test(n)){
        let _n = n
        n = Math.abs(n)
        n = n.toString()
        var re = /\d{1,3}(?=(\d{3})+$)/g
        var n1 = n.replace(/^(\d+)((\.\d+)?)$/, function (s, s1, s2) { return s1.replace(re, "$&,") + s2; })
        if(_n>=0){
          return n1
        }else{
          return '-' + n1
        }
      }else{
        return n
      }
    },

    Vue.prototype.toFixedNumber = function (n) {
      if(n * 1 > 0){
        return n.toFixed(2)
      } else{
        return n
      }
    },

    Vue.prototype.toFixedNumber1 = function (n) {
      if(n * 1 > 0){
        return n.toFixed(1)
      } else{
        return n
      }
    },

    Vue.prototype.toFixedNumber0 = function (n) {
      if(n * 1 > 0){
        return n.toFixed(0)
      } else{
        return n
      }
    },

    Vue.prototype.setCategoryData = function (_tree) {
      let _select = []
      if(_tree.list.length > 0){
        _select.push({
          value: _tree.list[0].value,
          levelname: 'category',
          label: _tree.list[0].value
        })
        if(_tree.list[0].subList &&
            _tree.list[0].subList[0].list.length > 0){
          for(let i=0; i<_tree.list[0].subList[0].list.length; i++){
            _select.push({
              value: _tree.list[0].subList[0].list[i].value,
              levelname: 'sub_category',
              label: _tree.list[0].subList[0].list[i].value
            })
            if(_tree.list[0].subList[0].list[i].subList &&
                _tree.list[0].subList[0].list[i].subList[0].list.length > 0){
              for(let j=0; j<_tree.list[0].subList[0].list[i].subList[0].list.length; j++){
                _select.push({
                  value: _tree.list[0].subList[0].list[i].subList[0].list[j].value,
                  levelname: 'product_type',
                  label: '- ' + _tree.list[0].subList[0].list[i].subList[0].list[j].value
                })
                if(_tree.list[0].subList[0].list[i].subList[0].list[j].subList &&
                  _tree.list[0].subList[0].list[i].subList[0].list[j].subList[0].list.length > 0){
                  for(let k=0; k<_tree.list[0].subList[0].list[i].subList[0].list[j].subList[0].list.length; k++){
                    _select.push({
                      value: _tree.list[0].subList[0].list[i].subList[0].list[j].subList[0].list[k].value,
                      levelname: 'product',
                      label: '-- ' + _tree.list[0].subList[0].list[i].subList[0].list[j].subList[0].list[k].value
                    })
                    if(_tree.list[0].subList[0].list[i].subList[0].list[j].subList[0].list[k].subList &&
                        _tree.list[0].subList[0].list[i].subList[0].list[j].subList[0].list[k].subList[0].list.length > 0){
                      for(let m=0; m<_tree.list[0].subList[0].list[i].subList[0].list[j].subList[0].list[k].subList[0].list.length; k++){
                        _select.push({
                          value: _tree.list[0].subList[0].list[i].subList[0].list[j].subList[0].list[k].subList[0].list[m].value,
                          levelname: 'spec_segment',
                          label: '- ' + _tree.list[0].subList[0].list[i].subList[0].list[j].subList[0].list[k].subList[0].list[m].value
                        })
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      return _select
    }
    
  }
}
